/**
 * @module  Experience/SoftGoods
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/**
 * Constants for Softgoods module
 */
export const SOFTGOODS_CONSTANTS = {
  browsePlansAEMPath: 'plans/individual.content',
  // maxPlanDetailLength: 2,
  browsePlan: '/browse-plans-phone',
  phonePlans: 'plans/phonePlans',
  tabletPlans: 'plans/tabletPlans',
  accordionIndex: 2,
  PRODUCT_SELECTOR: '/product-selector/setup',
  BROWSE_PLAN_PHONE: '/browse-plans-phone',
  PLAN_ID: 'changeExistingPlan',
  PRIMARY_CLASS: 'btn btn-primary',
  SECONDARY_CLASS: 'btn btn-secondary',
  TYPE: 'secondary',
  SUBMIT: 'submit',
  CONTACT_US_URL: 'contactUsURL',
  SELECT_LINE_URL: '/resume-cancellation/select-line',
  RATE_SERVICES_URL: '/change-plans-services/rate-services',
  ANON: 'ANON',
  CART_URL: '/cart',
  VOICE: 'Voice',
  MIXED_CART_ERROR: 'BIZ_0001_INVALID_TRANS_TYPE',
  CONTINUE: 'continue',
  VIEW_CART: 'viewcart',
  BROWSE_PHONE: '/browse-phones',
};

export const SOFTGOODS_MODULE_COMPONENTS = {
  SOFTGOODS_MODULE_NAME: 'Softgoods Module',
  SOFTGOODS_SERVICE: 'SoftgoodsService',
  BROWSE_PLAN_LANDING_COMPONENT: 'BrowsePlansLandingComponent',
};
